import React from 'react';

const About = () => {
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-12">
          <h1 className="display-5 fw-bold mb-5 text-center">Hakkımızda</h1>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-lg-6">
          <h2 className="h3 mb-4">İsilti Saz Evi</h2>
          <p className="lead">
            Geleneksel Türk müziği aletlerinin üretimi ve satışında 
            uzman olan firmamız, kaliteli işçilik ve doğal malzemeler 
            kullanarak müzik severlere hizmet vermektedir.
          </p>
          <p>
            Yıllardır süregelen deneyimimiz ile, her bir enstrümanı 
            özenle üretiyor ve müşterilerimizin beklentilerini 
            karşılayacak kalitede ürünler sunuyoruz.
          </p>
        </div>
        <div className="col-lg-6">
          <div className="bg-primary text-white p-5 rounded">
            <h3 className="h4 mb-4">Vizyonumuz</h3>
            <p>
              Geleneksel Türk müziği kültürünü yaşatmak ve 
              gelecek nesillere aktarmak için kaliteli enstrümanlar 
              üretmeye devam etmek.
            </p>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-md-4 mb-4">
          <div className="text-center">
            <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '80px', height: '80px'}}>
              <i className="bi bi-award fs-2"></i>
            </div>
            <h4>Kalite</h4>
            <p className="text-muted">
              En kaliteli malzemeler ve deneyimli işçilik ile üretim
            </p>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="text-center">
            <div className="bg-success text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '80px', height: '80px'}}>
              <i className="bi bi-heart fs-2"></i>
            </div>
            <h4>Tutku</h4>
            <p className="text-muted">
              Müziğe olan tutkumuz ile her detayda mükemmellik
            </p>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="text-center">
            <div className="bg-info text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '80px', height: '80px'}}>
              <i className="bi bi-people fs-2"></i>
            </div>
            <h4>Müşteri Odaklı</h4>
            <p className="text-muted">
              Müşteri memnuniyeti her zaman önceliğimiz
            </p>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="bg-light p-5 rounded">
            <h3 className="h4 mb-4 text-center">Tarihçemiz</h3>
            <div className="row">
              <div className="col-md-6">
                <p>
                  İsilti Saz Evi, geleneksel Türk müziği aletlerinin 
                  üretimi konusunda uzmanlaşmış bir aile işletmesidir. 
                  Kuşaklar boyu aktarılan bilgi ve deneyim ile, 
                  her bir enstrümanı titizlikle üretmekteyiz.
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  Müşterilerimizin ihtiyaçlarını anlayarak, onlara 
                  en uygun çözümleri sunmaya devam ediyoruz. 
                  Kalite ve müşteri memnuniyeti bizim en büyük 
                  önceliğimizdir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
